import React from "react";
import { AdvancedRealTimeChart } from "react-ts-tradingview-widgets";
import { Box, Paper, Grid } from "@mui/material";
import OrderList from "./components/order-list";
import OrderBook from "./components/order-book";
import {
  Order,
  useClosedOrdersQuery,
  useOpenOrdersQuery,
  useOrderBookQuery,
} from "features/trade/tradeApi";

const Trade = () => {
  const { data: orderBook } = useOrderBookQuery(
    { symbol: "BTC/USD" },
    {
      pollingInterval: 5000,
    }
  );

  const { data: openOrdersData } = useOpenOrdersQuery(
    { symbol: "BTC/USD" },
    {
      pollingInterval: 2000,
    }
  );

  let openOrders: Order[] = [];

  if (openOrdersData && openOrdersData.result) {
    openOrders = openOrdersData.orders;
  }

  const { data: allOrdersData } = useClosedOrdersQuery(
    { symbol: "BTC/USD" },
    {
      pollingInterval: 5000,
    }
  );

  let allOrders: Order[] = [];

  if (allOrdersData && allOrdersData.result) {
    allOrders = allOrdersData.orders;
  }

  const asks = orderBook?.asks.filter((a) => a.price) || [];
  const bids = orderBook?.bids.filter((b) => b.price) || [];

  return (
    <Box p={2}>
      {/* Top Section */}
      <Grid container spacing={2} height="60vh">
        <Grid item xs={8}>
          <Paper elevation={3} sx={{ height: "100%", p: 2 }}>
            <AdvancedRealTimeChart
              theme="dark"
              autosize
              height={400}
              symbol="BTCUSD"
            />
          </Paper>
        </Grid>
        <Grid item xs={4}>
          <Grid container spacing={2} height="60vh">
            <Grid item xs={12}>
              <Paper elevation={3} sx={{ height: "100%", p: 2 }}>
                <OrderBook items={asks} title="Asks" type="buy" />
              </Paper>
            </Grid>
            <Grid item xs={12}>
              <Paper elevation={3} sx={{ height: "100%", p: 2 }}>
                <OrderBook items={bids} title="Bids" type="sell" />
              </Paper>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      {/* Bottom Section */}
      <Grid container spacing={2} height="40vh" mt={4}>
        <Grid item xs={8}>
          <Paper elevation={3} sx={{ height: "100%", p: 2 }}>
            <OrderList openOrders={openOrders} closedOrders={allOrders} />
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Trade;
